import { render, staticRenderFns } from "./LanguagePicker.vue?vue&type=template&id=071ff9e2&scoped=true&"
import script from "./LanguagePicker.vue?vue&type=script&lang=js&"
export * from "./LanguagePicker.vue?vue&type=script&lang=js&"
import style0 from "./LanguagePicker.vue?vue&type=style&index=0&id=071ff9e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071ff9e2",
  null
  
)

export default component.exports